import { cn } from '@mlm/ui/lib/cn';

/**
 * The breathing ring: a hairline circle that grows while the member breathes in
 * and shrinks while they breathe out, over exactly `durationMs`. With reduced
 * motion the circle jumps between sizes and the cue still changes, so nobody is
 * asked to follow an animation they have turned off.
 */
export function BreathRing({
  scale,
  durationMs,
  cue,
  detail,
  size = 'md',
}: {
  /** The size to reach, between `BREATH_SCALE.out` and `BREATH_SCALE.in`. */
  scale: number;
  /** How long to take getting there; 0 sets it at once (paused, or a hold). */
  durationMs: number;
  cue: string;
  detail?: string;
  size?: 'md' | 'lg';
}) {
  const box = size === 'lg' ? 'h-56 w-56 lg:h-72 lg:w-72' : 'h-44 w-44';
  return (
    <div className="flex flex-col items-center py-2">
      <div className={cn('flex items-center justify-center', box)}>
        <div
          aria-hidden
          className={cn(
            'rounded-full border border-[rgba(16,32,26,0.35)] transition-transform ease-[cubic-bezier(0.37,0,0.63,1)] motion-reduce:transition-none',
            box,
          )}
          style={{
            transform: `scale(${scale})`,
            transitionDuration: `${Math.max(0, durationMs)}ms`,
          }}
        />
      </div>
      <p className="eyebrow mt-5" aria-live="polite">
        {cue}
      </p>
      {detail && <p className="mt-2 font-mono text-sm tabular-nums text-sage">{detail}</p>}
    </div>
  );
}
